import { TAdminPracticesResponse } from '@mybonum/api';

import { TPracticeType } from '@/modules/practices/types.ts';

export const normalizeData = (data: TAdminPracticesResponse['result']): TPracticeType[] =>
    data.map((item) => ({
        id: item.id,
        name: item.name,
    }));
